import { useState, useEffect, useCallback } from 'react';
import PageHeader from "../../components/common/PageHeader";
import ApiService from "../../api/ApiService";
import moment from 'moment';
import GoToTop from "../../helpers/GoToTop";

const SringarDarshanGallery = () => {
    const [galleries, setGalleries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeGalleryId, setActiveGalleryId] = useState();
    const [visibleCount, setVisibleCount] = useState(8);
    const [top, setTop] = useState(0);
    // ⬅️ controls how many items are shown
    const festRef = useCallback((node) => {
        if (node) {
            setTop(node.offsetTop - 115);
        }
    }, []);
    useEffect(() => {
        const fetchGalleries = async () => {
            setLoading(true);
            try {
                const response = await ApiService.fetchDailyDarshanGalleries();

                if (response) {
                    const parsed = Object.keys(response).map((title, index) => {
                        const sortedItems = response[title].sort((a, b) =>
                            moment(b.date).valueOf() - moment(a.date).valueOf()
                        );
                        return {
                            id: index,
                            title,
                            items: sortedItems
                        };
                    });

                    parsed.sort((a, b) => {
                        const aLatest = moment(a.items[0]?.date || 0).valueOf();
                        const bLatest = moment(b.items[0]?.date || 0).valueOf();
                        return bLatest - aLatest;
                    });
                    setGalleries(parsed);

                    const srinagarGallery = parsed.find(g => g.title === "sringar");
                    setActiveGalleryId(srinagarGallery ? srinagarGallery.id : 0);
                } else {
                    setGalleries([]);
                }
            } catch (error) {
                console.error("Error fetching galleries:", error);
                setGalleries([]);
            } finally {
                setLoading(false);
            }
        };
        fetchGalleries();
    }, []);

    const getActiveGallery = () => {
        return galleries.find(g => g.id === activeGalleryId) || { title: '', items: [] };
    };

    const getDisplayTitle = (key) => {
        switch (key) {
            case "mangala": return "Mangala Darshan";
            case "sringar": return "Sringar Darshan";
            case "festival-darshan": return "Festival Darshan";
            default: return "";
        }
    };

    const handleLoadMore = () => {
        setVisibleCount(prev => prev + 8);
    };

    return (
        <>
            <div className="sringar-darshan-page">
                <PageHeader title="Daily Darshan" imgSrc="/images/page-header/03.webp" />

                <section className="category-selector py-4 bg-light" ref={festRef}>
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="d-flex justify-content-center flex-wrap">
                                    {galleries.map(gallery => (
                                        <button
                                            key={gallery.id}
                                            className="btn mx-2 mb-2"
                                            style={
                                                activeGalleryId === gallery.id
                                                    ? { backgroundColor: '#F3B01B', color: '#fff', border: '1px solid #F3B01B' }
                                                    : { backgroundColor: 'transparent', color: '#F3B01B', border: '1px solid #F3B01B' }
                                            }
                                            onClick={() => {
                                                setActiveGalleryId(gallery.id);
                                                setVisibleCount(8); // reset on gallery change
                                            }}
                                        >
                                            {getDisplayTitle(gallery.title)}
                                        </button>
                                    )).reverse()}
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

                <section className="darshan-gallery py-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-10 mx-auto">
                                <div className="heading text-center mb-5">
                                    <h2 className="head-1">
                                        {getDisplayTitle(getActiveGallery().title)}
                                    </h2>
                                </div>
                            </div>
                        </div>

                        {loading ? (
                            <div className="text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className="row">
                                    {getActiveGallery().items.slice(0, visibleCount).map((item, index) => (
                                        <div className="col-md-3 mt-3" key={index}>
                                            <div className="card shadow-sm h-100">
                                                <a href={`/daily-darshan-gallery/${getActiveGallery().title}/${item.date}`}>
                                                    <img
                                                        src={`${process.env.REACT_APP_S3_URL}/uploads/${getActiveGallery().title}/${item.thumbnail}`}
                                                        alt={item.date}
                                                        className="card-img-top img-fluid"
                                                        style={{ height: "250px", objectFit: "cover" }}
                                                    />
                                                </a>
                                                <div className="card-body mt-0 p-3 d-flex flex-column">
                                                    {getActiveGallery().title === "festival-darshan" && (
                                                        <small style={{ color: "#F3B01B" }}>
                                                            {item?.festival_title || ""}
                                                        </small>
                                                    )}

                                                    <div className="mt-auto d-flex justify-content-between align-items-center">
                                                        <small className="card-title" style={{ color: "#f3b01b" }}>
                                                            {moment(item.date).format("MMM D, YYYY")}
                                                        </small>
                                                        <a
                                                            href={`/daily-darshan-gallery/${getActiveGallery().title}/${item.date}`}
                                                            className="btn btn-sm"
                                                            style={{ backgroundColor: '#F3B01B', color: '#fff', border: '1px solid #F3B01B' }}
                                                        >
                                                            VIEW ALL
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {visibleCount < getActiveGallery().items.length && (
                                    <div className="text-center mt-4">
                                        <button
                                            className="btn btn-sm"
                                            style={{ backgroundColor: '#F3B01B', color: '#fff', border: '1px solid #F3B01B' }}
                                            onClick={handleLoadMore}
                                        >
                                            Load More
                                        </button>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </section>
            </div>
            <GoToTop top={top} />
        </>
    );
};

export default SringarDarshanGallery;
